import { render, staticRenderFns } from "./role-select.vue?vue&type=template&id=0d5f7e58&scoped=true"
import script from "./role-select.vue?vue&type=script&lang=js"
export * from "./role-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f7e58",
  null
  
)

export default component.exports